"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylableDriver = exports.USAGE_MAPPING_ALLOW_ALL = exports.CONTROLLER_PART_TYPE_PROPNAME = exports.ARCHETYPE_PROPNAME = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@stylable/core");
var stylable_forcestates_plugin_1 = require("@stylable/webpack-extensions/dist/stylable-forcestates-plugin");
var postcss_safe_parser_1 = tslib_1.__importDefault(require("postcss-safe-parser"));
var create_elements_tree_1 = require("./create-elements-tree");
var mutable_ast_1 = require("./mutable-ast");
var stylable_aggregation_1 = require("./stylable-aggregation");
var stylable_site_vars_1 = require("./stylable-site-vars");
var stylable_stylesheet_1 = require("./stylable-stylesheet");
var native_pseudo_elements_set_1 = require("./utils/native-pseudo-elements-set");
var memory_minimal_fs_1 = require("./memory-minimal-fs");
exports.ARCHETYPE_PROPNAME = '-archetype';
exports.CONTROLLER_PART_TYPE_PROPNAME = '-controller-part-type';
var USAGE_MAPPING_ALLOW_ALL = function () { return true; };
exports.USAGE_MAPPING_ALLOW_ALL = USAGE_MAPPING_ALLOW_ALL;
var PROJECT_ROOT = '/';
function wrapRequireWithInlineModules(requireModule, inlineModules) {
    return function (id) {
        var inlineModule = inlineModules[id];
        return inlineModule ? inlineModule : requireModule(id);
    };
}
var StylableDriver = /** @class */ (function () {
    function StylableDriver(buildHook, alias, usageMapping, // TODO: Deprecate
    experiments) {
        if (alias === void 0) { alias = {}; }
        if (usageMapping === void 0) { usageMapping = {}; }
        if (experiments === void 0) { experiments = {}; }
        var _this = this;
        this.usageMapping = usageMapping;
        this.experiments = experiments;
        this.updateState = {};
        this.batching = false; // if true - updateFromAst is blocked
        this.transformationPlugins = [];
        this.aggregationCache = new Map();
        this.fsSource = {};
        this.entries = [];
        this.buildHooks = [];
        this.fileHooks = [];
        this.selectionHooks = [];
        var _a = (0, memory_minimal_fs_1.createMinimalFS)({ files: this.fsSource }), fs = _a.fs, requireModule = _a.requireModule;
        this.fs = fs;
        buildHook && this.registerBuildHook(buildHook);
        this.jsModules = Object.create(null);
        var requireModuleWithInlineModules = wrapRequireWithInlineModules(requireModule, this.jsModules);
        var resolveOptions = {
            unsafeCache: true,
            symlinks: false,
            alias: alias,
        };
        var defaultResolver = (0, core_1.createDefaultResolver)(this.fs, resolveOptions);
        var resolveModule = function (directoryPath, request) {
            return _this.jsModules[request] ? request : defaultResolver(directoryPath, request);
        };
        this.stylable = core_1.Stylable.create({
            projectRoot: PROJECT_ROOT,
            fileSystem: this.fs,
            requireModule: requireModuleWithInlineModules,
            resolveOptions: resolveOptions,
            resolveModule: resolveModule,
            cssParser: postcss_safe_parser_1.default,
        });
    }
    StylableDriver.prototype.readFile = function (path) {
        // this assumes memory fs uses the object it was passed as the files.
        // should be changed to fs.exist ? fs.readFileSync : null
        return (this.fsSource[path] && this.fsSource[path].content) || null;
    };
    StylableDriver.prototype.removeFile = function (path) {
        this.fs.removeFileSync(path);
    };
    StylableDriver.prototype.setEntries = function (entries) {
        this.entries = entries;
    };
    StylableDriver.prototype.aggregateSelectorDeclarations = function (sheetPath, selector, filter, useRawDecl, 
    // We don't open background shorthands since they are fully opened by the background-driver
    disableBackgroundShorthand) {
        if (disableBackgroundShorthand === void 0) { disableBackgroundShorthand = true; }
        var sheetPaths = Array.isArray(sheetPath) ? sheetPath : [sheetPath];
        if (filter === undefined && useRawDecl === undefined) {
            var cacheKey = sheetPaths.join(':;') + ':;' + selector;
            var decls = this.aggregationCache.get(cacheKey);
            if (!decls) {
                decls = (0, stylable_aggregation_1.aggregateSelectorDeclarations)(this, sheetPaths, selector, undefined, undefined, disableBackgroundShorthand);
                this.aggregationCache.set(cacheKey, decls);
            }
            return decls;
        }
        else {
            return (0, stylable_aggregation_1.aggregateSelectorDeclarations)(this, sheetPaths, selector, filter, useRawDecl, disableBackgroundShorthand);
        }
    };
    StylableDriver.prototype.writeFile = function (path, content) {
        if (content === this.readFile(path)) {
            return;
        }
        this.fs.writeFileSync(path, content);
        if (this.fileHooks.length) {
            this.fileHooks.forEach(function (hook) { return hook(content, [path]); });
        }
        this.stylable.process(path);
    };
    StylableDriver.prototype.buildFromRawCSS = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, entries = _b.entries, _c = _b.emitBuild, emitBuild = _c === void 0 ? true : _c;
        var entriesArray = entries || this.entries;
        var css = entriesArray.map(function (path) { return _this.readFile(path); }).join('\n');
        if (this.buildHooks.length && emitBuild !== false) {
            this.buildHooks.forEach(function (hook) { return hook(css, entriesArray); });
        }
        return css;
    };
    /*
    sets a single event listener which will be fire when
    - output (built) css changes - if fileChangeHook is false (default)
    OR
    - a source file changes - if fileChangeHook is true
     */
    //TODO change function names to be more generic and deprecate
    /**@deprecated - probably not in use anywhere*/
    StylableDriver.prototype.setBuildHook = function (buildHook, fileChangeHook) {
        if (fileChangeHook === void 0) { fileChangeHook = false; }
        if (fileChangeHook) {
            this.fileHooks = [buildHook];
        }
        else {
            this.buildHooks = [buildHook];
        }
    };
    /*
    Registers an event listener which will be fire when
    - output (built) css changes - if fileChangeHook is false (default)
    OR
    - a source file changes - if fileChangeHook is true
     */
    StylableDriver.prototype.registerBuildHook = function (buildHook, fileChangeHook) {
        if (fileChangeHook === void 0) { fileChangeHook = false; }
        var hookArray;
        if (fileChangeHook) {
            hookArray = this.fileHooks;
        }
        else {
            hookArray = this.buildHooks;
        }
        hookArray.push(buildHook);
    };
    StylableDriver.prototype.unregisterBuildHook = function (buildHook, fileChangeHook) {
        if (fileChangeHook === void 0) { fileChangeHook = false; }
        var hookArray;
        if (fileChangeHook) {
            hookArray = this.fileHooks;
        }
        else {
            hookArray = this.buildHooks;
        }
        var hookIndex = hookArray.indexOf(buildHook);
        !!~hookIndex && hookArray.splice(hookIndex, 1);
    };
    StylableDriver.prototype.registerSelectionHook = function (selectionHook) {
        this.selectionHooks.push(selectionHook);
    };
    StylableDriver.prototype.unregisterSelectionHook = function (selectionHook) {
        var hookIndex = this.selectionHooks.indexOf(selectionHook);
        if (hookIndex >= 0) {
            this.selectionHooks.splice(hookIndex, 1);
        }
    };
    StylableDriver.prototype.buildCSS = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, entries = _b.entries, _c = _b.emitBuild, emitBuild = _c === void 0 ? true : _c;
        var entriesArray = entries || this.entries;
        var css = entriesArray
            .map(function (entry) {
            var meta = _this.stylable.transform(_this.getStylesheetMeta(entry)).meta;
            _this.applyEditorTransformations(meta);
            return meta.outputAst.toString();
        })
            .join('\n');
        if (this.buildHooks.length && emitBuild !== false) {
            this.buildHooks.forEach(function (hook) { return hook(css, entriesArray); });
        }
        return css;
    };
    StylableDriver.prototype.applyEditorTransformations = function (meta) {
        (0, stylable_forcestates_plugin_1.applyStylableForceStateSelectors)(meta.outputAst, exports.USAGE_MAPPING_ALLOW_ALL || this.usageMapping);
        return meta;
    };
    // TODO: protected?
    StylableDriver.prototype.getStylesheetMeta = function (path) {
        return this.stylable.process(path);
    };
    StylableDriver.prototype.getTransformer = function () {
        return this.stylable.createTransformer();
    };
    StylableDriver.prototype.setScope = function (scope) {
        this.scope = scope || undefined;
    };
    StylableDriver.prototype.getScope = function () {
        return this.scope;
    };
    StylableDriver.prototype.getStylesheet = function (path) {
        var meta = this.getStylesheetMeta(path);
        // TODO: When does this return null?
        return meta
            ? new stylable_stylesheet_1.StylesheetDriver(this.getStylesheetMeta.bind(this, path), this.updateFileFromAST.bind(this, path), this.getTransformer.bind(this), this.getScope(), this.transformationPlugins, this.experiments)
            : null;
    };
    StylableDriver.prototype.reloadSiteColors = function () {
        if (this.siteVarsDriver) {
            this.siteVarsDriver.loadSiteColors();
            this.aggregationCache.clear();
        }
    };
    StylableDriver.prototype.getSiteVarsDriver = function (path) {
        if (!this.siteVarsDriver) {
            var sheet = this.getStylesheet(path);
            if (!sheet) {
                return null;
            }
            this.siteVarsDriver = new stylable_site_vars_1.StylableSiteVars(sheet);
        }
        return this.siteVarsDriver;
    };
    StylableDriver.prototype.getSelectorTypePath = function (sheetPath, selector) {
        var resolved = this.getElementResolved(sheetPath, selector);
        if (!resolved) {
            return '';
        }
        if (resolved.length === 1) {
            return resolved[0].meta.source;
        }
        var root = tslib_1.__spreadArray([], tslib_1.__read(resolved), false).reverse().find(function (resolve) { return resolve.symbol.name === 'root'; }) || null;
        return root ? root.meta.source : '';
    };
    StylableDriver.prototype.getPseudoElements = function (sheetPath, selector) {
        var resolved = this.getElementResolved(sheetPath, selector);
        if (!resolved) {
            return [];
        }
        var extendedElements = resolved.filter(function (resolve) { return resolve.symbol.name === 'root'; });
        var res = new Set();
        extendedElements.forEach(function (extendedElement) {
            Object.keys(extendedElement.meta.classes)
                .filter(function (name) { return name !== 'root'; })
                .forEach(function (name) {
                res.add(name);
            });
        });
        return Array.from(res);
    };
    StylableDriver.prototype.getPseudoElementsDeep = function (sheetPath, selector) {
        return (0, create_elements_tree_1.createElementsTree)(this.getStylesheetMeta(sheetPath), selector, this.stylable.resolver);
    };
    StylableDriver.prototype.getTargetClass = function (sheetPath, className) {
        var meta = this.getStylesheetMeta(sheetPath);
        return this.getTransformer().scope(className, meta.namespace);
    };
    /***/
    // private getASTForPath(path: string){ return this.getStylesheetMeta(path).rawAst; }
    StylableDriver.prototype.getPreprocessorValue = function (preprocessorPropName, sheetPath, selector) {
        var sheet = this.getStylesheet(sheetPath);
        if (!sheet) {
            return undefined;
        }
        var foundPreprocessorValueInFirstSheet = findPreprocessorValueInSheet(sheet, selector);
        if (foundPreprocessorValueInFirstSheet) {
            return foundPreprocessorValueInFirstSheet;
        }
        var meta = sheet.getMeta();
        var elements = this.getTransformer().resolveSelectorElements(meta, selector)[0];
        var _a = elements[elements.length - 1], resolved = _a.resolved, name = _a.name;
        if (resolved.length === 0 && native_pseudo_elements_set_1.nativePseudoElementsSet.has(name)) {
            var part = elements[elements.length - 2];
            return part ? findValueInResolved(this, part.resolved, name) : undefined;
        }
        return findValueInResolved(this, resolved);
        function findValueInResolved(driver, resolved, nativePseudo) {
            var e_1, _a;
            if (resolved.length < 1) {
                return undefined;
            }
            try {
                for (var resolved_1 = tslib_1.__values(resolved), resolved_1_1 = resolved_1.next(); !resolved_1_1.done; resolved_1_1 = resolved_1.next()) {
                    var cssResolve = resolved_1_1.value;
                    var allegedSheet = driver.getStylesheet(cssResolve.meta.source);
                    var allegedClassName = cssResolve.symbol.name;
                    if (allegedSheet) {
                        var foundPreprocessorValue = findPreprocessorValueInSheet(allegedSheet, '.' + allegedClassName + (nativePseudo ? "::".concat(nativePseudo) : ''));
                        if (foundPreprocessorValue) {
                            return foundPreprocessorValue;
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (resolved_1_1 && !resolved_1_1.done && (_a = resolved_1.return)) _a.call(resolved_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return undefined;
        }
        // check if it is the requested preprocessor declaration, and return it if so:
        function findPreprocessorValueInSheet(allegedSheet, allegedClassName) {
            var rules = allegedSheet.queryStyleRule(allegedClassName);
            if (rules.length > 0 && rules[0].nodes) {
                var preprocessorDecl = rules[rules.length - 1].nodes // TODO check with barak
                    .find(function (decl) { return decl.prop === preprocessorPropName; });
                if (preprocessorDecl) {
                    // rule has the requested preprocessor:
                    return preprocessorDecl.value;
                }
            }
            // not the requested preprocessor declaration
            return undefined;
        }
    };
    // TODO concept should be expanded and moved to stylable as -st-archetype
    StylableDriver.prototype.getArchetypeName = function (sheetPath, name) {
        return this.getPreprocessorValue(exports.ARCHETYPE_PROPNAME, sheetPath, name);
    };
    StylableDriver.prototype.getControllerPartType = function (sheetPath, selector) {
        return this.getPreprocessorValue(exports.CONTROLLER_PART_TYPE_PROPNAME, sheetPath, selector);
    };
    // TODO: Move to stylable
    // TODO: mixins that resolve to root should return all used variables in stylesheet
    StylableDriver.prototype.getCSSMixinOverrides = function (sheetPath, name) {
        var resolvedSymbol = this.resolveSymbol(sheetPath, name);
        if (!resolvedSymbol) {
            return [];
        }
        var sheet = this.getStylesheet(resolvedSymbol.from);
        if (!sheet) {
            return [];
        }
        return sheet.getCSSMixinOverrides(resolvedSymbol.name);
    };
    StylableDriver.prototype.getExperiments = function () {
        return this.experiments;
    };
    StylableDriver.prototype.resolveSymbol = function (from, name) {
        var sheet = this.getStylesheet(from);
        if (!sheet) {
            return null;
        }
        var symbol = sheet.getSymbol(name);
        if (!symbol) {
            return null;
        }
        if (symbol._kind === 'import') {
            return this.resolveSymbol(symbol.import.from, symbol.name !== 'default' ? symbol.name : 'root');
        }
        else if (symbol._kind !== 'class') {
            return null;
        }
        return { from: from, name: name };
    };
    /**
     * runs a given function and prevents ast transform to occur while running it
     * @param path - path of file being updated
     * @param func - function to be run
     * @param cb - callback to be called by updateFromAST after transform
     */
    StylableDriver.prototype.batch = function (path, func, cb) {
        var _this = this;
        // Start blocking updates:
        this.batching = true;
        func();
        // release blocking updates:
        this.batching = false;
        if (Array.isArray(path)) {
            path.forEach(function (path) { return _this.updateFromAST(path, cb); });
        }
        else {
            this.updateFromAST(path, cb);
        }
    };
    StylableDriver.prototype.updateFileFromAST = function (path, modified, cb) {
        this.updateFromAST(path, cb);
        return (0, mutable_ast_1.updateNodeRevision)(modified);
    };
    StylableDriver.prototype.registerJsModule = function (key, mixin) {
        this.jsModules[key] = mixin;
    };
    StylableDriver.prototype.registerJsModules = function (mixins) {
        var _this = this;
        Object.keys(mixins).forEach(function (key) { return _this.registerJsModule(key, mixins[key]); });
    };
    StylableDriver.prototype.registerTransformationPlugins = function (plugins) {
        var _a;
        (_a = this.transformationPlugins).push.apply(_a, tslib_1.__spreadArray([], tslib_1.__read(plugins), false));
    };
    StylableDriver.prototype.unregisterJsModule = function (key) {
        delete this.jsModules[key];
    };
    StylableDriver.prototype.clearFsCache = function (filterFunc) {
        var cache = this.stylable.fileProcessor.cache;
        Object.keys(cache)
            .filter(filterFunc)
            .forEach(function (key) {
            delete cache[key];
        });
    };
    StylableDriver.prototype.clearCache = function (path) {
        var e_2, _a, e_3, _b;
        var cacheToRemove = [];
        try {
            for (var _c = tslib_1.__values(this.aggregationCache.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var key = _d.value;
                if (key.includes(path)) {
                    cacheToRemove.push(key);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        try {
            for (var cacheToRemove_1 = tslib_1.__values(cacheToRemove), cacheToRemove_1_1 = cacheToRemove_1.next(); !cacheToRemove_1_1.done; cacheToRemove_1_1 = cacheToRemove_1.next()) {
                var key = cacheToRemove_1_1.value;
                this.aggregationCache.delete(key);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (cacheToRemove_1_1 && !cacheToRemove_1_1.done && (_b = cacheToRemove_1.return)) _b.call(cacheToRemove_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    StylableDriver.prototype.updateFromAST = function (path, cb) {
        var _this = this;
        if (this.batching) {
            return;
        }
        if (this.updateState[path] === undefined) {
            this.updateState[path] = { callbacks: [], lock: 0 };
        }
        // Update FS immediately:
        this.updateFsFromAst(path);
        this.clearCache(path);
        var stylesheet = this.getStylesheet(path);
        // restore source meta ref (should be same value)
        var meta = stylesheet.getMeta();
        // update CSS and runtime
        this.stylable.transform(meta);
        if (!this.updateState[path].lock) {
            this.updateState[path].lock = setTimeout(function () {
                // TODO: change hard coded /site.st.css
                _this.buildCSS({ entries: _this.entries });
                _this.updateState[path].callbacks.forEach(function (func) { return func(); });
                _this.updateState[path].callbacks = [];
                _this.updateState[path].lock = 0;
            }, 10);
        }
        if (cb && !~this.updateState[path].callbacks.indexOf(cb)) {
            this.updateState[path].callbacks.push(cb);
        }
    };
    StylableDriver.prototype.updateFsFromAst = function (path) {
        var stylesheet = this.getStylesheet(path);
        var currentSourceAst = stylesheet.AST;
        // update FS
        this.writeFile(path, stylesheet.source);
        var meta = stylesheet.getMeta();
        meta.rawAst = currentSourceAst; // restore mutable-ast metadata
    };
    StylableDriver.prototype.getElementResolved = function (sheetPath, selector) {
        var meta = this.getStylesheetMeta(sheetPath);
        var transformer = this.getTransformer();
        var elements = transformer.resolveSelectorElements(meta, selector)[0];
        if (selector.split('::').length !== elements.length) {
            return null;
        }
        return elements[elements.length - 1].resolved;
    };
    return StylableDriver;
}());
exports.StylableDriver = StylableDriver;
//# sourceMappingURL=stylable-driver.js.map